import FullPageLoader from 'components/common/FullPageLoader';
import {
    buildInvoiceGroups,
    buildSpecialProjectGroups,
    getInvoiceGroupByConfig,
    getSpecialProjectGroupByConfig,
} from 'helpers/invoiceGrouping';
import { usePermissions } from 'layouts/Admin';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const InvoicePdfForm = ({
    data,
    invoiceNumber,
    loader,
    type,
    isOriginal,
    versionNumber,
    editedDate,
    isCurrent,
    isManualCurrent,
    isDeleted,
    showDelete,
    onDeleteClick,
    showRestore,
    onRestoreClick,
    showMakeCurrent,
    onMakeCurrentClick,
    user,
}) => {
    const { t } = useTranslation();
    const { checkPermission } = usePermissions();
    const clientData = data;

    const totalBill = (
        (clientData?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0) || 0) +
        ((clientData?.special_projects || clientData?.special_project)?.reduce((sum, item) => sum + Number(item?.amount || 0), 0) || 0)
    ).toFixed(2);

    const show = (value) => value !== null && value !== undefined && value !== '' && value !== 'N/A';
    const watermarkText = data?.status?.toLowerCase() === 'paid' ? 'MayaBridge' : 'MayaBridge';

    const renderLine = (label, value) => {
        if (!show(value)) return null;
        return (
            <>
                <span>{label}: {value}</span><br />
            </>
        );
    };

    const getExceededTime = (scheduledDate, scheduledEnd, actualDate, actualEnd) => {
        if (!scheduledDate || !scheduledEnd || !actualDate || !actualEnd) return null;

        const scheduledEndMoment = moment(`${scheduledDate} ${scheduledEnd}`, "YYYY-MM-DD HH:mm:ss");
        const actualEndMoment = moment(`${actualDate} ${actualEnd}`, "YYYY-MM-DD HH:mm:ss");

        if (!scheduledEndMoment.isValid() || !actualEndMoment.isValid()) return null;

        const exceededSeconds = actualEndMoment.diff(scheduledEndMoment, "seconds");
        if (exceededSeconds <= 0) return null;

        return moment.utc(exceededSeconds * 1000).format("HH:mm:ss");
    };

    const getFullDuration = (actualStartDate, actualStartTime, actualEndDate, actualEndTime) => {
        if (!actualStartDate || !actualStartTime || !actualEndDate || !actualEndTime) return null;

        const startMoment = moment(`${actualStartDate} ${actualStartTime}`, "YYYY-MM-DD HH:mm:ss");
        const endMoment = moment(`${actualEndDate} ${actualEndTime}`, "YYYY-MM-DD HH:mm:ss");

        if (!startMoment.isValid() || !endMoment.isValid()) return null;

        const durationMinutes = endMoment.diff(startMoment, "minutes");
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;

        if (hours > 0 && minutes > 0) return `${hours} hour ${minutes} minute`;
        if (hours > 0) return `${hours} hour`;
        if (minutes > 0) return `${minutes} minute`;
        return "0 minute";
    };

    const renderActualStartTime = (appointmentDate, checkinDate, checkinTime) => {
        if (!checkinTime || !checkinDate) return null;

        const isSameDate = appointmentDate &&
            moment(checkinDate).format("YYYY-MM-DD") === moment(appointmentDate).format("YYYY-MM-DD");

        if (isSameDate) {
            return renderLine(
                'Actual Start Time',
                moment(checkinTime, "HH:mm:ss").format("h:mm A")
            );
        }

        return renderLine(
            'Actual Start Date Time',
            `${moment(checkinDate).format("DD/MM/YYYY")} ${moment(checkinTime, "HH:mm:ss").format("h:mm A")}`
        );
    };

    const renderScheduledStartTime = (date, startTime, endTime, timezone) => {
        if (!date || !startTime) return null;

        const crossesMidnight = endTime &&
            moment(endTime, "HH:mm:ss").isBefore(moment(startTime, "HH:mm:ss"));

        const timezoneName = timezone?.name;
        const dateTime = timezoneName
            ? moment.tz(`${date} ${startTime}`, "YYYY-MM-DD HH:mm:ss", timezoneName)
            : moment(`${date} ${startTime}`, "YYYY-MM-DD HH:mm:ss");

        const formattedTime = dateTime.format("h:mm A");
        const timezoneInfo = timezoneName
            ? ` (${dateTime.format("z")} / GMT${dateTime.format("Z")})`
            : '';

        if (crossesMidnight) {
            return renderLine(
                t('invoice.scheduledStartDateTime'),
                `${dateTime.format("DD/MM/YYYY")} ${formattedTime}${timezoneInfo}`
            );
        }

        return renderLine(
            t('invoice.scheduledStartTime'),
            `${formattedTime}${timezoneInfo}`
        );
    };

    const groupByConfig = getInvoiceGroupByConfig(clientData?.invoice_group_by || '');
    const groupedAppointments = buildInvoiceGroups(clientData?.appointments || [], groupByConfig.join(','));
    const specialProjects = clientData?.special_projects || clientData?.special_project || [];
    const specialProjectGroupByValue = clientData?.invoice_group_by || '';
    const specialProjectGroupByConfig = getSpecialProjectGroupByConfig(specialProjectGroupByValue);
    const groupedSpecialProjects = buildSpecialProjectGroups(
        specialProjects,
        specialProjectGroupByConfig.join(',')
    );
    console.log(groupedAppointments,'groupedAppointmentssss');
    console.log(clientData,'groupedAppointmentssss2222');
    console.log(user,'userssssss');

    return (
        <>
            <div className="page"  style={{ position: 'relative', overflow: 'hidden' }}>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%) rotate(-25deg)',
                        fontSize: '90px',
                        fontWeight: 700,
                        color: 'rgba(0, 0, 0, 0.10)',
                        letterSpacing: '8px',
                        textTransform: 'uppercase',
                        userSelect: 'none',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        pointerEvents: 'none',
                        zIndex: 2,
                        opacity: 0.15,
                    }}
                >
                    {/* {watermarkText} */}
                    <img src="/invoice-icon.svg" alt="Logo" />
                </div>
                <header style={{ position: 'relative', zIndex: 1 }}>
                    <div className="us">
                        <img src="/main-logo.png" alt="Logo" />
                    </div>

                    {/* <div className='d-flex align-items-center'>
                        {show(data?.invoice_number || invoiceNumber) && (
                            <div className="title">
                                <h4>{versionLabel ? `${versionLabel} ` : ''}INVOICE # {data?.invoice_number || invoiceNumber}</h4>
                            </div>
                        )}
                        <div className="title">
                            <h4>
                                Date: {data?.billing_date
                                    ? new Date(data.billing_date).toLocaleDateString('en-GB')
                                    : new Date().toLocaleDateString('en-GB')}
                            </h4>
                        </div>
                    </div> */}

                    <div className='d-flex align-items-start' style={{ justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {show(data?.invoice_number || invoiceNumber) && (
                                <div className="title">
                                    <h4>
                                        {isOriginal ? t('invoice.originalInvoice', { invoiceNumber: data?.invoice_number || invoiceNumber }) : (
                                            <>
                                                {t('invoice.editedInvoice', { versionNumber: versionNumber || '' })}
                                                {isCurrent && (
                                                    <span style={{backgroundColor: '#10b981', color: '#ffffff', padding: '9px', borderRadius: '12px', fontSize: '12px', marginLeft: '8px', verticalAlign: 'middle' }} className="seagreen-without-box-shadow">
                                                        {t('invoice.current')}
                                                    </span>
                                                )}
                                                {isDeleted && (
                                                    <span style={{backgroundColor: '#ef4444', color: '#ffffff', padding: '9px', borderRadius: '12px', fontSize: '12px', marginLeft: '8px', verticalAlign: 'middle' }} className="tomatoRed-without-box-shadow">
                                                        {t('invoice.deleted')}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </h4>
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', gap: '4px' }}>
                            <div className="title" style={{margin:0}}>
                                <h4 style={{ margin: 0 }}>
                                    {isOriginal ? t('invoice.dateLabel') : t('invoice.editedOn')}: {
                                        isOriginal
                                            ? (data?.billing_date
                                                ? new Date(data.billing_date).toLocaleDateString('en-GB')
                                                : new Date().toLocaleDateString('en-GB'))
                                            : (editedDate
                                                ? new Date(editedDate).toLocaleDateString('en-GB')
                                                : new Date().toLocaleDateString('en-GB'))
                                    }
                                </h4>
                            </div>
                            <div className='pdf-hide-buttons d-flex justify-content-center align-items-center gap-2'>
                                { /* Make Current button area - shown for non-current, non-deleted revisions */ }
                                {typeof showMakeCurrent !== 'undefined' && showMakeCurrent && onMakeCurrentClick && (
                                    <button
                                        type="button"
                                        onClick={onMakeCurrentClick}
                                        title={t('invoice.makeCurrentInvoice')}
                                        className="main_button"
                                        style={{boxShadow:'none'}}
                                        
                                    >
                                        {/* <i className="fa-solid fa-check-circle" style={{ marginRight: '4px' }}></i> */}
                                        {t('invoice.makeCurrent')}
                                    </button>
                                )}
                                { /* Delete button area - shown for intermediate revisions via prop */ }
                                {typeof showDelete !== 'undefined' && showDelete && onDeleteClick && (
                                    <button
                                        type="button"
                                        onClick={onDeleteClick}
                                        title={t('invoice.deleteRevision')}
                                        className="main_button tomatoRed-without-box-shadow"
                                        style={{boxShadow:'none'}}
                                    >
                                        {/* <i className="fa-solid fa-trash" style={{ fontSize: '14px' }}></i> */}
                                        {t('common.delete')}
                                    </button>
                                )}
                                { /* Restore button area - shown for deleted revisions via prop */ }
                                {typeof showRestore !== 'undefined' && showRestore && onRestoreClick && (
                                    <button
                                        type="button"
                                        onClick={onRestoreClick}
                                        title={t('invoice.restoreRevision')}
                                        className="main_button seagreen-without-box-shadow"
                                        style={{boxShadow:'none'}}
                                    >
                                        {/* <i className="fa-solid fa-rotate-left" style={{ fontSize: '14px' }}></i> */}
                                        {t('invoice.restore')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </header>

                <section>
                    {isOriginal && (
                    <div className="billed-to">
                        <h1>{t('invoice.billTo')}</h1>
                        {show(clientData?.client?.user?.name) && <h2>{clientData?.client.user.name}</h2>}
                        {show(clientData?.client?.billing_person) && <h3>{clientData?.client.billing_person}</h3>}
                        {show(clientData?.client?.billing_email) && <h3>{clientData?.client.billing_email}</h3>}
                        {show(clientData?.client?.billing_zipcode || clientData?.client?.city?.name) && (
                            <h3>{clientData?.client?.billing_zipcode} {clientData?.client?.city?.name}</h3>
                        )}
                        {show(clientData?.client?.state?.name) && <h3>{clientData?.client.state.name}</h3>}
                    </div>
                    )}

                    {!isOriginal && (
                    <div className="billed-to">
                        <h1>{t('invoice.editedBy')}</h1>
                        {show(user?.name) && <h2>{user.name}</h2>}
                        {show(user?.email) && <h3>{user.email}</h3>}
                    </div>
                    )}

                    <div className="invoice-table-wrapper">
                        {clientData?.appointments?.length > 0 && (
                            <h2 className="mb-3" style={{ fontWeight: 700 }}>{t('invoice.interpretation')}</h2>
                        )}
                        {clientData?.appointments?.length > 0 && (
                        <table className="invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{t('invoice.description')}</th>
                                    <th>{t('invoice.cost')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groupedAppointments.map((group, groupIndex) => (
                                    <React.Fragment key={`${group.key}-${groupIndex}`}>
                                        {groupByConfig.length > 0 && (
                                            <tr>
                                                <td colSpan="3">
                                                    <strong>{group.label}</strong>
                                                </td>
                                            </tr>
                                        )}
                                        {group.appointments.map((val, index) => {
                                            const totalHours = val?.invoice?.total_hours;
                                            const totalMinutes = totalHours
                                                ? (parseInt(totalHours.split(":")[0]) * 60) + parseInt(totalHours.split(":")[1])
                                                : 0;

                                            const minDuration = val?.invoice?.min_duration;
                                            const minDurUnit = val?.invoice?.duration_unit;
                                            const minDurationMinutes = minDurUnit === 'hour' ? minDuration * 60 : minDuration;
                                            const isValid = totalMinutes >= minDurationMinutes;

                                            const inc = val?.invoice?.incremental;
                                            const incremental =
                                                inc === '30_minute' ? '30 minute' :
                                                inc === '1_hour' ? 'hourly' :
                                                inc === 'minute' ? 'per minute' : null;

                                            const exceededTime = getExceededTime(
                                                val.date, val.end_time,
                                                val.appointment_assign?.checkin_date, val.appointment_assign?.checkout_time
                                            );

                                            const fullDuration = getFullDuration(
                                                val.appointment_assign?.checkin_date,
                                                val.appointment_assign?.checkin_time,
                                                val.appointment_assign?.checkout_date,
                                                val.appointment_assign?.checkout_time
                                            );

                                            // const hasCustomPricing = !!val?.appointment_custom_pricing;
                                            const customPricing = val?.appointment_custom_pricing;

                                            const hasCustomPricing =
                                                Number(customPricing?.mileage_total || 0) > 0 ||
                                                Number(customPricing?.travel_total || 0) > 0 ||
                                                Number(customPricing?.discount || 0) > 0 ||
                                                Number(val?.invoice?.rush_fee || 0) > 0;

                                            const dynamicFieldsList = (() => {
                                                try {
                                                    const parsed = val?.appointment_details?.dynamic_fields
                                                        ? JSON.parse(val.appointment_details.dynamic_fields)
                                                        : [];
                                                    return Array.isArray(parsed) ? parsed.filter(f => f?.show_in_invoice === true) : [];
                                                } catch {
                                                    return [];
                                                }
                                            })();

                                            return (
                                                <tr key={`${group.key}-${index}`}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        {show(val?.appid) && (
                                                            <>
                                                                <span>
                                                                    {t('invoice.appointmentNumber')}:&nbsp;
                                                                    {checkPermission('Detail Appointments')
                                                                        ? <Link to={`/appointments/view/${val.id}`}>{val.appid}</Link>
                                                                        : val.appid}
                                                                </span>
                                                                <br />
                                                            </>
                                                        )}

                                                        {/* {type !== 'compressed' && ( */}
                                                            <>
                                                                {renderLine(t('invoice.language'), val?.language?.name)}

                                                                {val?.status !== 'completed' && renderLine(t('invoice.status'), val?.status)}
                                                                {renderLine(
                                                                    t('invoice.date'),
                                                                    // val?.date && `${moment(val.date).format("DD/MM/YYYY")} (${val?.appointment_details?.timezone?.abbreviation} / GMT${val?.appointment_details?.timezone?.utc_offset})`
                                                                    val?.date && `${moment(val.date).format("DD/MM/YYYY")}`
                                                                )}

                                                                {show(val?.type) && (
                                                                    <>
                                                                        <span>
                                                                            {t('invoice.modality')}:&nbsp;
                                                                            {/* {val?.type} */}
                                                                            {val?.type}
                                                                        </span>
                                                                        
                                                                        <span className="font-bold text-red-600">
                                                                            {' ('}
                                                                            {minDuration && `min duration: ${minDuration} ${minDurUnit}`}
                                                                            {')'}
                                                                        </span>
                                                                        <br />
                                                                    </>
                                                                )}

                                                                {show(val?.type) && (
                                                                    <>
                                                                        <span>
                                                                            {t('invoice.type')}:&nbsp;
                                                                            <span className="invoice-subject">
                                                                                {val?.subject}
                                                                            </span>
                                                                        </span>

                                                                        {(isValid === false || incremental) && (
                                                                            <span className="font-bold text-red-600">
                                                                                {' ('}
                                                                                {incremental && `${t('invoice.incremental')}: ${incremental}`}
                                                                                {')'}
                                                                            </span>
                                                                        )}
                                                                        <br />
                                                                    </>
                                                                )}

                                                                {/* {val?.date && val?.start_time && renderLine(
                                                                    t('invoice.scheduledStartTime'),
                                                                    `${moment(val.start_time, "HH:mm:ss").format("h:mm A")}`
                                                                )} */}
                                                                {renderScheduledStartTime(
                                                                    val?.date,
                                                                    val?.start_time,
                                                                    val?.end_time,
                                                                    val?.appointment_details?.timezone
                                                                )}

                                                                {renderLine(t('invoice.scheduledDuration'), `${val?.estimated_duration} ${val?.estimated_duration_unit}`)}

                                                                {renderActualStartTime(
                                                                    val?.date,
                                                                    val?.appointment_assign?.checkin_date,
                                                                    val?.appointment_assign?.checkin_time
                                                                )}

                                                                {fullDuration && renderLine(t('invoice.actualDuration'), `${fullDuration}`)}
                                                                {fullDuration && renderLine(t('invoice.totalBillableDuration'), `${val?.invoice?.extra_duration} ${t('invoice.minutes')}`)}

                                                                {show(val?.invoice?.rate) && renderLine(
                                                                    t('invoice.rate'),
                                                                    `$${val.invoice.rate}/${val.invoice.rate_unit || ''}`
                                                                )}

                                                                {val?.invoice?.rush_fee > 0 && (
                                                                    <>
                                                                        <span>
                                                                            {t('invoice.rushFee')}: ${val.invoice.rush_fee}
                                                                            <span className="font-bold text-red-600">
                                                                                {' ('}{t('invoice.scheduledWithin24Hours')}{')'}
                                                                            </span>
                                                                        </span><br />
                                                                    </>
                                                                )}

                                                                {renderLine(t('invoice.facilityName'), val?.appointment_details?.facility?.facility_name)}

                                                                {Number(clientData?.requester_details_show_invoice) === 1 && (
                                                                    <>
                                                                        {renderLine(t('invoice.requestorName'), val?.appointment_details?.requester_name)}
                                                                        {renderLine(t('invoice.requestorEmail'), val?.appointment_details?.requester_email)}
                                                                        {renderLine(t('invoice.requestorPhone'), val?.appointment_details?.requester_phone)}
                                                                    </>
                                                                )}
                                                                {renderLine(
                                                                    t('invoice.vendorId'),
                                                                    val?.interpreter && `${val.interpreter.code}`
                                                                )}
                                                                {Number(clientData?.interpreter_name_show_invoice) === 1 &&
                                                                    renderLine(
                                                                        t('invoice.vendorName'),
                                                                        val?.interpreter && (
                                                                            val.interpreter.vendor_type === 'agency'
                                                                                ? (val.agency_interpreter_name || val.agencyInterpreter?.name || `${val.interpreter.first_name} ${val.interpreter.last_name}`)
                                                                                : `${val.interpreter.first_name} ${val.interpreter.last_name}`
                                                                        )
                                                                    )
                                                                }
                                                                {renderLine(t('invoice.comments'), val?.appointment_assign?.comments)}

                                                                {dynamicFieldsList.length > 0 && (
                                                                    <>
                                                                        <strong>{t('invoice.extraFields')}</strong>
                                                                        <br />
                                                                    </>
                                                                )}

                                                                {dynamicFieldsList.map((f, i) => (
                                                                    <React.Fragment key={i}>
                                                                        {renderLine(f?.name, f?.value)}
                                                                    </React.Fragment>
                                                                ))}

                                                                {val?.invoice && (
                                                                    <>
                                                                        {hasCustomPricing ? (
                                                                            <>
                                                                                <strong>{t('invoice.costBreakdown')}</strong>
                                                                                <br />
                                                                                <span>
                                                                                    {`${t('invoice.rate')} ($${val?.invoice?.rate}/${val.invoice.rate_unit || ''})`} × {val?.invoice?.extra_duration || 0} {t('invoice.minutes')}
                                                                                </span>
                                                                                <br />
                                                                                {val?.appointment_custom_pricing?.mileage_total > 0 && (
                                                                                    <>
                                                                                        <span>+ {t('invoice.mileageTotal')}: ${val?.appointment_custom_pricing?.mileage_total}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                                {val?.appointment_custom_pricing?.travel_total > 0 && (
                                                                                    <>
                                                                                        <span>+ {t('invoice.travelTotal')}: ${val?.appointment_custom_pricing?.travel_total}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                                {/* {(val?.appointment_custom_pricing?.sub_total > 0 && val?.appointment_custom_pricing?.discount > 0) && (
                                                                                    <>
                                                                                        <span>= Sub Total: ${val?.appointment_custom_pricing?.sub_total}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )} */}
                                                                                {val?.appointment_custom_pricing?.discount > 0 && (
                                                                                    <>
                                                                                        <span>+ {t('invoice.discount')}: {val?.appointment_custom_pricing?.discount}%</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                                {val?.invoice?.rush_fee > 0 && (
                                                                                    <>
                                                                                        <span>+ {t('invoice.rushFeeLine')}: ${val?.invoice?.rush_fee}</span>
                                                                                        <br />
                                                                                    </>
                                                                                )}
                                                                                <span className="font-bold">
                                                                                    = {t('invoice.totalCost')}: ${val?.invoice?.total_amount?.toFixed(2)}
                                                                                </span>
                                                                            </>
                                                                        ) : (
                                                                            <span className="font-bold">
                                                                                {t('invoice.totalCost')}: ${val?.invoice?.total_amount?.toFixed(2)}
                                                                            </span>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </>
                                                        {/* )} */}
                                                    </td>
                                                    <td>
                                                        ${val?.invoice?.total_amount
                                                            ? val.invoice.total_amount.toFixed(2)
                                                            : '0.00'}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                        )}

                        {specialProjects.length > 0 && (
                            <div className={clientData?.appointments?.length > 0 ? "mt-4" : ""}>
                                <h2 style={{ fontWeight: 700 }}>{t('invoice.specialProject')}</h2>
                                <table className="invoice-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{t('invoice.description')}</th>
                                            <th>{t('invoice.cost')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {groupedSpecialProjects.map((group, groupIndex) => (
                                            <React.Fragment key={`${group.key}-${groupIndex}`}>
                                                {specialProjectGroupByConfig.length > 0 && (
                                                    <tr>
                                                        <td colSpan="3"><strong>{group.label}</strong></td>
                                                    </tr>
                                                )}
                                                {group.projects.map((project, index) => {
                                            const vendorName = [
                                                project?.interpreter?.first_name,
                                                project?.interpreter?.last_name
                                            ]
                                                .filter(Boolean)
                                                .join(' ');
                                            return(
                                            <tr key={project.id || index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {show(project?.translation?.transid) && (
                                                    <>
                                                        <span>
                                                            {t('invoice.projectNumber')}:&nbsp;
                                                            {checkPermission('Detail Appointments')
                                                                ? <Link to={`/translation/view/${project?.translation?.id}`}>{project?.translation?.transid}</Link>
                                                                : project?.translation?.transid}
                                                        </span>
                                                        <br />
                                                    </>
                                                )}
                                                {/* {type !== 'compressed' && ( */}
                                                    <>
                                                        {/* {renderLine(t('invoice.status'), project?.translation?.status)} */}
                                                        {renderLine(t('invoice.date'), project?.translation?.created_at && moment(project.translation.created_at).format('DD/MM/YYYY'))}
                                                        {renderLine(t('invoice.subAccount'), project?.translation?.subclient?.subaccount_name)}
                                                        {renderLine(t('invoice.department'), project?.translation?.translation_details?.department?.department_name)}
                                                        {renderLine(t('invoice.sourceLanguage'), project?.translation?.language?.name)}

                                                        {renderLine(
                                                        t('invoice.targetLanguage'),
                                                        project?.translation?.translation_target_languages
                                                            ?.map(item => item?.language?.name)
                                                            .join(', ')
                                                        )}

                                                        {renderLine(t('invoice.notes'), project?.translation?.translation_details?.notes)}
                                                        {Number(clientData?.interpreter_name_show_invoice) === 1 &&
                                                            renderLine(t('invoice.vendorName'), vendorName)}
                                                        {Number(clientData?.requester_details_show_invoice) === 1 && (
                                                            <>
                                                                {renderLine(t('invoice.requesterName'), project?.translation?.requester_name)}
                                                                {renderLine(t('invoice.requesterEmail'), project?.translation?.translation_details?.requester_email)}
                                                                {renderLine(t('invoice.requesterPhone'), project?.translation?.translation_details?.requester_phone)}
                                                            </>
                                                        )}

                                                        {renderLine(
                                                        t('invoice.currentPhase'),
                                                        <span className="text-capitalize">
                                                            {project?.translation?.translation_details?.current_phase?.replaceAll("_", " ")}
                                                        </span>
                                                        )}

                                                        {(() => {
                                                            const currentPhase =
                                                                project?.translation?.translation_details?.current_phase?.toLowerCase();
                                                            if (currentPhase === 'review')
                                                                return renderLine(t('invoice.totalPageCount'), project?.translation?.total_words_count);
                                                            if (currentPhase === 'transcription' || currentPhase === 'other')
                                                                return renderLine(t('invoice.totalAudioMinutes'), project?.translation?.total_words_count);
                                                            return renderLine(t('invoice.totalWordCount'), project?.translation?.total_words_count);
                                                        })()}

                                                        {(() => {
                                                            const currentPhase =
                                                                project?.translation?.translation_details?.current_phase?.toLowerCase();

                                                            const rateUnit = currentPhase === 'review'
                                                                ? t('invoice.perPage')
                                                                : (currentPhase === 'transcription' || currentPhase === 'other'
                                                                    ? t('invoice.perMinute')
                                                                    : t('invoice.perWord'));

                                                            const hasSpecialProjectBreakdown =
                                                                Number(project?.rush_fee || 0) > 0 ||
                                                                Number(project?.formatting || 0) > 0;

                                                            if (!hasSpecialProjectBreakdown) {
                                                                return renderLine(t('invoice.rate'), `$${project?.rate || 0} ${rateUnit}`);
                                                            }

                                                            return (
                                                                <>
                                                                    <strong>{t('invoice.costBreakdown')}</strong>
                                                                    <br />

                                                                    <span>
                                                                        {`${t('invoice.rate')} ($${project?.rate || 0})`} × {project?.translation?.total_words_count || 0}
                                                                    </span>
                                                                    <br />

                                                                    {Number(project?.rush_fee || 0) > 0 && (
                                                                        <>
                                                                            <span>+ {t('invoice.rushFeeLine')}: ${project?.rush_fee}</span>
                                                                            <br />
                                                                        </>
                                                                    )}

                                                                    {Number(project?.formatting || 0) > 0 && (
                                                                        <>
                                                                            <span>+ {t('invoice.formatting')}: ${project?.formatting}</span>
                                                                            <br />
                                                                        </>
                                                                    )}

                                                                    <span className="font-bold">
                                                                        = {t('invoice.totalCost')}: ${Number(project?.amount || 0).toFixed(2)}
                                                                    </span>
                                                                </>
                                                            );
                                                        })()}
                                                    </>
                                                {/* )} */}
                                            </td>
                                            <td>${Number(project?.amount || 0).toFixed(2)}</td>
                                        </tr>
                                                )})}
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <table className="info-container last_info">
                        <tbody>
                            <tr>
                                <th className='text-end last_due'>{t('invoice.totalDue')}</th>
                                <th className='text-end last_due'>${totalBill}</th>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>

            {loader && <FullPageLoader />}
        </>
    );
};

export default InvoicePdfForm;
